module.exports = __webpack_public_path__ + "img/warm-close.ae805f44.png";